import { Column } from 'src/shared/components/Semantic/all'
import { ColorsTab } from './ColorsTab'
import { ProductTab } from './ProductTab'
import { VariantsTab } from './VariantsTab'

export const TabContent = ({
  activeTab,
  productId,
  onSaveHandlerReady,
  onHasChangesChange,
}: {
  activeTab: string
  productId: number
  onSaveHandlerReady?: (handler: () => void) => void
  onHasChangesChange?: (hasChanges: boolean) => void
}) => {
  if (!productId) return null

  return (
    <>
      <div style={{ display: activeTab === 'product' ? 'block' : 'none' }}>
        <ProductTab
          productId={productId}
          onSaveHandlerReady={activeTab === 'product' ? onSaveHandlerReady : undefined}
          onHasChangesChange={activeTab === 'product' ? onHasChangesChange : undefined}
        />
      </div>
      <div style={{ display: activeTab === 'variants' ? 'block' : 'none' }}>
        <VariantsTab
          productToUpdate={productId}
          onHasChangesChange={activeTab === 'variants' ? onHasChangesChange : undefined}
          onSaveHandlerReady={activeTab === 'variants' ? onSaveHandlerReady : undefined}
        />
      </div>
      <div style={{ display: activeTab === 'colors' ? 'block' : 'none' }}>
        <ColorsTab
          productToUpdate={productId}
          onHasChangesChange={activeTab === 'colors' ? onHasChangesChange : undefined}
        />
      </div>
    </>
  )
}

